import {TaxInvoiceListElementType, TaxInvoiceListMapType, TaxInvoiceSearchParamType} from "../interface";
import moment from "moment";

export const taxInvoiceSearchParamInit: TaxInvoiceSearchParamType = {
    taxFlag: "N",
    fromDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    limit: 10,
    pageNo: 1,
    //내부수정: 키워드 초기화
    keyword1: "",
    keywordType1: "1",
    keyword2: "",
    keywordType2: "1",
};

export const taxInvoiceListMapInit: TaxInvoiceListMapType = {
    list: [],
    totalCount: 0
};

export const taxInvoiceListElementInit: TaxInvoiceListElementType = {
    customerName: "",
    endDt: "",
    endNo: "",
    enduserName: "",
    newShipmentTaxId: 0,
    issueDate: "",
    newDAmount: 0,
    newLCustomerValue: "",
    newLEnduserValue: "",
    newShipmentId: "",
    owneridValue: "",
    owningUserName: "",
    remark: "",
    taxCharge: "",
    taxContact: "",
    taxEmail: "",
    taxFlag: "",
    taxNo: "",
    taxState: "",
    taxTotal: 0,
    totalAmount: 0
};